import * as React from 'react';
import cn from 'classnames';

import Button from '../../../../../Button';
import { useTheme } from '../../../../../theme';
import { Add, Minus } from '../../../../../Icons';

interface Props {
	showAddSegment: boolean;
	showRemoveSegment: boolean;
	canRemoveSegment: boolean;
	isAlternativeView: boolean;
	onAddSegment: () => void;
	removeLastSegment: () => void;
}

const Actions = React.memo<Props>(
	({ canRemoveSegment, showAddSegment, showRemoveSegment, onAddSegment, removeLastSegment, isAlternativeView }) => {
		const { Actions: css } = useTheme('SearchForm');

		return (
			<div
				className={cn(css.actions, {
					[css.actions_alternative]: isAlternativeView
				})}
			>
				<Button
					className={cn(css.addSegment, {
						[css.addSegment_alternative]: isAlternativeView
					})}
					onClick={showAddSegment ? onAddSegment : null}
					disabled={!showAddSegment}
				>
					{Add}
				</Button>

				{canRemoveSegment && (
					<Button
						className={cn(css.removeSegment, {
							[css.removeSegment_alternative]: isAlternativeView
						})}
						onClick={removeLastSegment}
						disabled={!showRemoveSegment}
					>
						{Minus}
					</Button>
				)}
			</div>
		);
	}
);

export default Actions;
